module.exports = "/_next/static/images/logo_WEB_dark-eec1ffe0ce3cdfde4b794320ce5f635b.svg";